import React from "react";
import { CustomDialog } from "../../Shared/CustomDialog/CustomDialog";
import { CustomBox } from "../../Shared/CustomBox/CustomBox";
import { CustomImage } from "../../Shared/CustomImage/CustomImage";
import { CustomTypography } from "../../Shared/CustomTypography/CustomTypography";
import { CustomButton } from "../../Shared/CustomButton/CustomButton";
import { useNavigate } from "react-router-dom";

interface ReferralDetailsDialogProps {
  open: boolean;
  onClose: () => void;
  referral: any;
}

export const ReferralDetailsDialog: React.FC<ReferralDetailsDialogProps> = ({
  open,
  onClose,
  referral,
}) => {
  const navigate = useNavigate();

  if (!referral) return null;

  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      title="Referral Details"
      maxWidth="md"
      actions={
        <CustomButton
          variant="contained"
          onClick={() => {
            if (referral.referredToId) {
              navigate(`/user-layout/doctor-list/${referral.referredToId}`);
            }
          }}
        >
          Schedule Appointment
        </CustomButton>
      }
    >
      {/* Doctor Section */}
      <CustomBox mb={2}>
        <CustomImage
          src={referral.referredTo.avatar}
          width={50}
          height={50}
          radius="50%"
        />

        <CustomBox flexDirection="column" alignItems="flex-start" ml={2}>
          <CustomTypography fontWeight={600}>
            {referral.referredTo.name}
          </CustomTypography>

          <CustomTypography color="gray" fontSize={14}>
            {referral.referredTo.specialty}
          </CustomTypography>
        </CustomBox>
      </CustomBox>

      {/* Details Box */}
      <CustomBox
        flexDirection="column"
        alignItems="flex-start"
        sx={{
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          p: 2,
          width: "100%",
        }}
      >
        <CustomTypography>
          <strong>Date:</strong> {referral.date}
        </CustomTypography>

        <CustomTypography>
          <strong>Contact:</strong> {referral.contact}
        </CustomTypography>

        <CustomTypography>
          <strong>Email:</strong> {referral.email}
        </CustomTypography>

        <CustomTypography>
          <strong>Location:</strong> {referral.location}
        </CustomTypography>

        <CustomTypography>
          <strong>Reason:</strong> {referral.reason}
        </CustomTypography>
      </CustomBox>
    </CustomDialog>
  );
};
